<template>
	<div class="container">

		<div v-if="version=='jdb' || version=='ssb'" class="version-change" :style="{'top':version=='jdb'?'40px':'30px'}">
			<Dropdown>
		        <div style="height: 20px;">
		           <img src="@/assets/application.png" class="apps-menu">
		           <i class="apps-arrow ivu-icon ivu-icon-ios-arrow-down"></i>
		        </div>
		        <DropdownMenu slot="list">
		            <DropdownItem :disabled="version=='jdb'" @click.native="versionJdb">经典版</DropdownItem>
		            <DropdownItem :disabled="version=='ssb'" @click.native="versionSsb">时尚版</DropdownItem>
		        </DropdownMenu>
		    </Dropdown>
		</div>

		<div class="floating_ck" id="contact-gide">
			<dl>
		    	<dt></dt>
		    	<dd class="consult">
		        	<span style="cursor: pointer;">联系客服</span>
		        	<div class="floating_left" style="height: 80px;line-height: 50px !important;">
		        		<p style="height: 50px;"><a>曹嘉芯</a></p>
		        	</div>
		        </dd>
		        <dd class="words">
		        	<span style="cursor: pointer;">客服电话</span>
		        	<div class="floating_left" style="height: 80px;line-height: 50px !important;">
		        		<p style="height: 50px;"><a>18513835453</a></p>
		        	</div>
		        </dd>
		        <dd class="weixin">
		        	<span style="cursor: pointer;">微信</span>
		             <div class="floating_left" style="left:-258px;top:-160px;">
		             	<img alt="扫码关注" src="@/assets/index/floatLogo/erweima.jpg">
		             </div>
		        </dd>
		    </dl>
		</div>

	</div>

</template>

<script>
	export default {
		name: 'contact',
		data() {
			return {
			};
		},
		props: ["version"],
		methods:{
			versionJdb:function(){
				if(this.version == 'jdb'){
					return;
				}
				var storage=window.localStorage;
				storage.newversion = 'jdb';
				this.$router.push({path: '/'});
			},
			versionSsb:function(){
				if(this.version == 'ssb'){
					return;
				}
				var storage=window.localStorage;
				storage.newversion = 'ssb';
				this.$router.push({path: '/v2'});
			}
		},
		created:function(){
			if(this.version == 'jdb'){
				var storage=window.localStorage;
				if(storage && storage.newversion == 'ssb'){
					this.$router.push({path: '/v2'});
				}
			}
		}
	}
</script>

<style scoped>

	.version-change{position:fixed;right:40px;z-index: 10000;}
	.apps-menu {
	    width: 20px;
	    height: 20px;
	    cursor: pointer;
	}
	.apps-arrow {
	    position: relative;
	    top: -6px;
	    left: 2px;
	    cursor: pointer;
	}

	.floating_ck{position:fixed;right:20px;bottom: 80px;z-index: 10000;}
	.floating_ck dl dd{position:relative;width:80px;height:80px;background-color:#EDBD69;border-bottom:solid 1px #EDBD69;text-align:center;background-repeat:no-repeat;background-position:center 20%;}
	.floating_ck dl dd:hover{background-color:#DDAD59;border-bottom:solid 1px #DDAD59;}
	.floating_ck dl dd:hover .floating_left{display:block;}

	.cknoclick:hover{background-color:#DDAD59 !important; border-bottom:solid 1px #DDAD59;}
	.cknoclick .floating_left{background-color: #DDAD59 !important;}


	.floating_ck dd span{color:#fff;display:block;padding-top:54px;}
	._ck dd span{color:#fff;display:block;padding-top:54px;}
	.floating_left{position:absolute;left:-160px;top:0px;width:160px;height:80px;background-color:#DDAD59;border-bottom:solid 1px #DDAD59;display:none;}
	.floating_left a{color:#fff;line-height:80px;}

	.consult{background-image:url(../../../assets/index/floatLogo/qq.png);}
	.words{background-image:url(../../../assets/index/floatLogo/kfdh.png);}
	.weixin{background-image:url(../../../assets/index/floatLogo/weixin.png);}
</style>



// WEBPACK FOOTER //
// src/view/layout/contact/index.vue